module.exports = __webpack_public_path__ + "img/icons8-gmc.7b426806.svg";